export default __webpack_public_path__ + "static/media/illustration.56c11911.svg";